import { Component, OnInit } from '@angular/core';
import { LINKS } from '../../_mocks/links';
import { Location } from '@angular/common';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  links = LINKS;

  constructor(
    private location: Location
  ) { }

  ngOnInit() {
  }

  comparePath(path) {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(2);
    }
    titlee = titlee.split('/').pop();
    path = path.split('/').pop();
    return titlee === path;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/sidebar/sidebar.component.ts